(function ($) {
    if (!$) return;
  
    function applyExpandable($el) {
      if ($el.data('processed')) return;
      $el.data('processed', true);
  
      var html =
        '<div class="exp-preview">' + $el.html().trim() + '</div>' +
        '<div class="exp-full" style="display:none">' + $el.html().trim() + '</div>' +
        '<a href="#" class="toggle-link" aria-expanded="false">Show more</a>';
  
      $el.html(html);
    }
  
    function init() {
      $('.expandable').each(function () {
        applyExpandable($(this));
      });
    }
  
    $(init);
    document.addEventListener('shopify:section:load', init);
  
    $(document).on('click', '.toggle-link', function (e) {
      e.preventDefault();
      var $link = $(this);
      var $wrap = $link.closest('.expandable');
      $wrap.find('.exp-preview, .exp-full').toggle();
      var expanded = $link.attr('aria-expanded') === 'true';
      $link.attr('aria-expanded', !expanded).text(expanded ? 'Show more' : 'Show less');
    });
  })(window.jQuery);
  